import { mapState } from 'vuex';
export default {
  name: 'ViewDashboard',
  data: function () {
    return {
      valueDeterminate1: 70,
      valueDeterminate2: 30,
      valueDeterminate3: 10,
      Svalue: 80,
      imagetemp: './img/wabe.jpg',
      carouselItems: [{
        src: './img/example/cr01.jpg'
      }, {
        src: './img/example/cr02.jpg'
      }, {
        src: './img/example/cr03.jpg'
      }],
      treeItems: [{
        id: 1,
        name: 'Vuetify Human Resources',
        children: [{
          id: 2,
          name: 'Core team',
          children: [{
            id: 201,
            name: 'John'
          }, {
            id: 202,
            name: 'Kael'
          }, {
            id: 203,
            name: 'Nekosaur'
          }, {
            id: 204,
            name: 'Jacek'
          }, {
            id: 205,
            name: 'Andrew'
          }]
        }, {
          id: 3,
          name: 'Administrators',
          children: [{
            id: 301,
            name: 'Ranee'
          }, {
            id: 302,
            name: 'Rachel'
          }]
        }, {
          id: 4,
          name: 'Contributors',
          children: [{
            id: 401,
            name: 'Phlow'
          }, {
            id: 402,
            name: 'Brandon'
          }, {
            id: 403,
            name: 'Sean'
          }]
        }]
      }],
      open: [1, 2],
      search: null,
      caseSensitive: false,
      tiles: [{
        title: 'Industry',
        image: './img/dtwin-factory1.png'
      }
      // { title: 'Utilities', image: './img/dtwin-utilities.jpg' },
      // { title: 'Chemicals', image: './img/dtwin-factory.jpg' }
      ]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    filter() {
      return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined;
    }
  }
};